import WebService from "../WebService";

const Communication = {
  send_email(data) {
    return WebService.post("/communication/send_mail", data);
  }
};
export default Communication;
